import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { apiURL } from '@/clients/axios'
import { MenuItemDTO, MenuSectionDTO, RestaurantDTO } from '@/types/dto'

// Define a service using a base URL and expected endpoints
export const nestApi = createApi({
  reducerPath: 'nest',
  baseQuery: fetchBaseQuery({ baseUrl: apiURL }),
  endpoints: (builder) => ({
    getRestaurant: builder.query<RestaurantDTO, string>({
      query: (id) => `/restaurants/${id}`,
    }),
    getMenuSections: builder.query<
      (MenuSectionDTO & { items: MenuItemDTO[] })[],
      string
    >({
      query: (id) => `/restaurants/${id}/menu-sections?fields=["items"]`,
    }),
    getMenuItem: builder.query<MenuItemDTO, string>({
      query: (id) => `/menu-items/${id}`,
    }),
    getMenuItemRestaurant: builder.query<
      { restaurant: RestaurantDTO; menuItem: MenuItemDTO },
      { id: string; menuItemId: string }
    >({
      query: ({ id, menuItemId }) =>
        `/restaurants/${id}/menu-item/${menuItemId}`,
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetRestaurantQuery,
  useGetMenuSectionsQuery,
  useGetMenuItemQuery,
  useGetMenuItemRestaurantQuery,
} = nestApi
